import { render, staticRenderFns } from "./DepositDataTable.vue?vue&type=template&id=44ce29ed"
import script from "./DepositDataTable.vue?vue&type=script&lang=js"
export * from "./DepositDataTable.vue?vue&type=script&lang=js"
import style0 from "./DepositDataTable.vue?vue&type=style&index=0&id=44ce29ed&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports